"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _component = _interopRequireDefault(require("../component"));

var _access = _interopRequireDefault(require("../access"));

var _utils = _interopRequireDefault(require("../utils"));

var _uberUtils = _interopRequireDefault(require("../uber-utils"));

var _dateField = _interopRequireDefault(require("../fields/date-field"));

var _reorder = require("./reorder");

var _globals = _interopRequireDefault(require("../globals"));

var _registrar = _interopRequireDefault(require("../compiler/registrar"));

// Timestamps are set in the store as some stores, e.g. those backed by remote databases, may wish
// to manage the timestamps for better reliability.
//
// Structure of doc in a store, e.g.
//  {
//     id,
//     userId,
//     ...,
//     fieldValues: {
//       firstName,
//       lastName,
//       ...
//     }
//   }
// In other words, we nest the default fields in the root of the document and then nest the
// non-default fields in fieldValues. This is done because:
//   1. There are some properties, like the cursor, which should not be a field as they shouldn't be
//      displayed to the user. However, these fields need to be associated with the form.
//   2. It allows for the creation of extra properties in the future without adding them to the form
//      as default fields
//   3. Default fields are not included in the fieldValues as this allows the default fields,
//      especially the id to be at the root of the record and not nested in the fieldValues. We also
//      don’t want to duplicate these default fields in both the root of the record and in the field
//      values as this can waste memory when storing the data
//
// We use a numeric order attribute to order docs in a set, e.g. allowing for drag-to-order UIs. The
// downside to this approach, is that moving a doc requires updating the order of all subsequent
// docs (https://dba.stackexchange.com/q/36875/94046). A previous design used a beforeId, similar to
// the beforeKey construct in the Mapa, and this only required at most 2 writes to move a doc. The
// downside; however, was that stores can return data in any order, or there can be race conditions,
// which result in beforeIds for docs that don't exist. This problematic beforeIds cause a great
// deal of extra complexity.
var Store =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Store, _Component);

  function Store() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Store);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Store)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'Store');
    return _this;
  }

  (0, _createClass2.default)(Store, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(Store.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'where',
            component: 'Field'
          }]
        }
      }); // For mocking

      this._access = _access.default;
      this._globals = _globals.default;
      this._registrar = _registrar.default;

      if (!props || !props.muteDidLoad) {
        this._emitDidLoad();
      }
    }
  }, {
    key: "_tryAndHandleError",
    value: function () {
      var _tryAndHandleError2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(promiseFactory) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _uberUtils.default.tryAndDisplayErrorIfAPIError(promiseFactory));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function _tryAndHandleError(_x) {
        return _tryAndHandleError2.apply(this, arguments);
      }

      return _tryAndHandleError;
    }()
  }, {
    key: "_shouldSetToLastOrder",
    value: function _shouldSetToLastOrder(order, reorder) {
      return (order === null || order === undefined) && reorder;
    }
  }, {
    key: "createDoc",
    value: function () {
      var _createDoc = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(props) {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._tryAndHandleError(function () {
                  // Omit values based on access
                  var fieldValues = _this2._access.valuesCanCreate(props.form, {
                    default: false
                  });

                  var id = props.form.getValue('id');
                  var order = props.form.getValue('order');

                  if ((order === null || order === undefined) && !props.reorder) {
                    order = _reorder.Reorder.DEFAULT_ORDER;
                  }

                  return _this2._createDoc((0, _objectSpread2.default)({}, props, {
                    fieldValues: fieldValues,
                    id: id,
                    order: order
                  }));
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function createDoc(_x2) {
        return _createDoc.apply(this, arguments);
      }

      return createDoc;
    }()
  }, {
    key: "getDoc",
    value: function () {
      var _getDoc = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(props) {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this._tryAndHandleError(
                /*#__PURE__*/
                (0, _asyncToGenerator2.default)(
                /*#__PURE__*/
                _regenerator.default.mark(function _callee3() {
                  var docs;
                  return _regenerator.default.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!props.id) {
                            _context3.next = 4;
                            break;
                          }

                          return _context3.abrupt("return", _this3._getDoc(props));

                        case 4:
                          _context3.next = 6;
                          return _this3._getAllDocs((0, _objectSpread2.default)({}, props, {
                            showArchived: null
                          }));

                        case 6:
                          docs = _context3.sent;
                          return _context3.abrupt("return", docs.edges.length > 0 ? docs.edges[0].node : null);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }))));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getDoc(_x3) {
        return _getDoc.apply(this, arguments);
      }

      return getDoc;
    }()
  }, {
    key: "getAllDocs",
    value: function () {
      var _getAllDocs = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(props) {
        var _this4 = this;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this._tryAndHandleError(function () {
                  return _this4._getAllDocs(props);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAllDocs(_x4) {
        return _getAllDocs.apply(this, arguments);
      }

      return getAllDocs;
    }()
  }, {
    key: "_upsertDoc",
    value: function () {
      var _upsertDoc2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(props) {
        var id, exists;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                id = props.id;
                exists = false;

                if (!id) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 5;
                return this._hasDoc({
                  id: id
                });

              case 5:
                exists = _context6.sent;

              case 6:
                if (!exists) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt("return", this.updateDoc(props));

              case 10:
                return _context6.abrupt("return", this.createDoc(props));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _upsertDoc(_x5) {
        return _upsertDoc2.apply(this, arguments);
      }

      return _upsertDoc;
    }()
  }, {
    key: "upsertDoc",
    value: function () {
      var _upsertDoc3 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(props) {
        var _this5 = this;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this._tryAndHandleError(function () {
                  var id = props.form.getValue('id');
                  return _this5._upsertDoc((0, _objectSpread2.default)({}, props, {
                    id: id
                  }));
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function upsertDoc(_x6) {
        return _upsertDoc3.apply(this, arguments);
      }

      return upsertDoc;
    }()
  }, {
    key: "updateDoc",
    value: function () {
      var _updateDoc = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(props) {
        var _this6 = this;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this._tryAndHandleError(function () {
                  // Omit values based on access
                  var fieldValues = _this6._access.valuesCanUpdate(props.form, {
                    default: false
                  });

                  var id = props.form.getValue('id');
                  var order = props.form.getValue('order');
                  return _this6._updateDoc((0, _objectSpread2.default)({}, props, {
                    fieldValues: fieldValues,
                    id: id,
                    order: order
                  }));
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function updateDoc(_x7) {
        return _updateDoc.apply(this, arguments);
      }

      return updateDoc;
    }()
  }, {
    key: "archiveDoc",
    value: function () {
      var _archiveDoc = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(props) {
        var _this7 = this;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this._tryAndHandleError(function () {
                  return _this7._archiveDoc(props);
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function archiveDoc(_x8) {
        return _archiveDoc.apply(this, arguments);
      }

      return archiveDoc;
    }()
  }, {
    key: "restoreDoc",
    value: function () {
      var _restoreDoc = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(props) {
        var _this8 = this;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this._tryAndHandleError(function () {
                  return _this8._restoreDoc(props);
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function restoreDoc(_x9) {
        return _restoreDoc.apply(this, arguments);
      }

      return restoreDoc;
    }()
  }, {
    key: "_emitError",
    value: function _emitError(err) {
      this.emitChange('err', err);
    }
  }, {
    key: "_now",
    value: function _now() {
      // We use a DateField to avoid Firestore's automatic conversion of Date's to Firebase style
      // timestamps.
      var date = new _dateField.default({
        now: true
      });
      return date.getValue();
    }
  }, {
    key: "_buildDoc",
    value: function _buildDoc(_ref2) {
      var fieldValues = _ref2.fieldValues,
          id = _ref2.id,
          userId = _ref2.userId,
          order = _ref2.order;

      var createdAt = this._now();

      return {
        id: id ? id : _utils.default.uuid(),
        archivedAt: null,
        // Needed by the UI as a default
        createdAt: createdAt,
        updatedAt: createdAt,
        userId: userId ? userId : null,
        order: order,
        fieldValues: fieldValues
      };
    }
  }, {
    key: "_setDoc",
    value: function _setDoc(_ref3) {
      var doc = _ref3.doc,
          fieldValues = _ref3.fieldValues,
          archivedAt = _ref3.archivedAt,
          order = _ref3.order;

      if (fieldValues !== undefined) {
        // Merge so that we support partial updates
        doc.fieldValues = Object.assign(doc.fieldValues, fieldValues);
      }

      if (archivedAt !== undefined) {
        doc.archivedAt = archivedAt;
      }

      doc.updatedAt = this._now();

      if (order === undefined) {
        // Set to null instead of setting to undefined as stores like Firebase don't support undefined
        // values
        doc.order = _reorder.Reorder.DEFAULT_ORDER;
      } else {
        doc.order = order;
      }

      return doc;
    }
  }, {
    key: "_getUserId",
    value: function _getUserId() {
      if (this._registrar.client) {
        var session = this._registrar.client.user.getSession();

        if (session) {
          return session.user.id;
        }
      }
    }
  }]);
  return Store;
}(_component.default);

exports.default = Store;